import Typography from '@mui/material/Typography';

export const TextCaption: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <Typography variant="caption" color="text.secondary">
      {children}
    </Typography>
  );
};
